module.exports = __webpack_public_path__ + "img/exc-logo.f69bb6ff.png";